module.exports = __webpack_public_path__ + "img/folder2-open.978e1d83.svg";